(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ke-material-help"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.querySelector('[data-ke-material-help]');
  const panel = document.querySelector('#KeMaterialPopover');
  if (!config || !panel || panel.dataset.ready) return;
  panel.dataset.ready = 'true';
  document.body.append(panel);
  const content = panel.querySelector('[data-ke-help-content]');
  const closeButton = panel.querySelector('button');
  const label = config.querySelector('[data-ke-help-label]').textContent;
  const valid = ['P', 'M', 'K', 'N', 'S', 'H'];
  let active = null;

  function position() {
    if (!active || panel.hidden) return;
    const anchor = active.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    const viewportHeight = document.documentElement.clientHeight;
    panel.style.maxWidth = `${viewportWidth - 24}px`;
    const width = panel.offsetWidth, height = panel.offsetHeight;
    const x = Math.max(12, Math.min(anchor.left, viewportWidth - width - 12));
    const y = anchor.bottom + height + 12 <= viewportHeight ? anchor.bottom + 10 : anchor.top - height - 10;
    panel.style.left = `${x}px`;
    panel.style.top = `${Math.max(12, Math.min(y, viewportHeight - height - 12))}px`;
  }

  function close(restore = false) {
    const previous = active;
    const returnFocus = restore || panel.contains(document.activeElement);
    if (previous) {
      previous.removeAttribute('aria-describedby');
      if (previous.tagName === 'BUTTON') previous.setAttribute('aria-expanded', 'false');
    }
    active = null;
    panel.hidden = true;
    if (returnFocus && previous?.isConnected) {
      previous.focus({ preventScroll: true });
    }
  }

  function show(trigger) {
    const template = config.querySelector(`[data-ke-material-content="${trigger.dataset.keMaterial}"]`);
    if (!template) return;
    close();
    active = trigger;
    content.replaceChildren(template.content.cloneNode(true));
    panel.dataset.group = trigger.dataset.keMaterial;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-labelledby', 'KeMaterialTitle');
    panel.hidden = false;
    trigger.setAttribute('aria-describedby', panel.id);
    if (trigger.tagName === 'BUTTON') trigger.setAttribute('aria-expanded', 'true');
    position();
    closeButton.focus({ preventScroll: true });
  }

  function bind(trigger, code) {
    if (trigger.dataset.keMaterial) return;
    trigger.dataset.keMaterial = code;
    trigger.setAttribute('aria-label', `${label} ${code}`);
    trigger.setAttribute('aria-controls', panel.id);
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.addEventListener('click', () => {
      if (active === trigger) close(true);
      else show(trigger);
    });
  }

  function decorate() {
    document.querySelectorAll('.kiso:not([data-ke-help-ready])').forEach(badge => {
      const code = valid.find(value => badge.classList.contains(`kiso--${value.toLowerCase()}`));
      badge.dataset.keHelpReady = 'true';
      if (!code) return;
      badge.removeAttribute('title');
      const link = badge.closest('a');
      if (link) {
        if (link.matches('[data-iso-filter]')) {
          const wrapper = document.createElement('div');
          wrapper.className = 'ke-material-option';
          link.before(wrapper);
          wrapper.append(link);
          const info = document.createElement('button');
          info.type = 'button';
          info.className = 'ke-material-info';
          const mark = document.createElement('span');
          mark.textContent = 'i';
          mark.setAttribute('aria-hidden', 'true');
          info.append(mark);
          wrapper.append(info);
          bind(info, code);
        }
      } else {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `${badge.className} ke-material-icon`;
        button.dataset.keHelpReady = 'true';
        button.textContent = code;
        badge.replaceWith(button);
        bind(button, code);
      }
    });
  }

  closeButton.addEventListener('click', () => close(true));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); close(true); }
  });
  document.addEventListener('pointerdown', event => {
    if (active && !panel.contains(event.target) && !active.contains(event.target)) close();
  });
  document.addEventListener('focusin', event => {
    if (active && !panel.contains(event.target) && !active.contains(event.target)) close();
  });
  document.addEventListener('scroll', event => {
    if (active && !panel.contains(event.target)) close();
  }, true);
  window.addEventListener('resize', () => close());
  window.addEventListener('pagehide', () => close());
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; decorate(); });
  });
  function init() {
    decorate();
    const main = document.querySelector('main');
    if (main) observer.observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
